import React, { useState, useEffect  } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Button,
    TextField,
    Typography,
    InputAdornment,
    IconButton,
    Alert,
    CircularProgress,
    Divider,
    Paper,
} from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import axiosInstance from "./Axiosinstance";
const Login = () => {
    const navigate = useNavigate();

     // If token exists, skip login page entirely

    //     useEffect(() => {
    //     const token = localStorage.getItem("token");
    //     const role  = localStorage.getItem("userRole");
    //     if (token) {
    //         if (role === "ADMIN" || role === "MANAGER") navigate("/admin/dashboard", { replace: true });
    //         else if (role === "SALES") navigate("/sales/dashboard", { replace: true });
    //         else navigate("/", { replace: true });
    //     }
    // }, [navigate]);

    useEffect(() => {
    const token = localStorage.getItem("token");
    const role  = localStorage.getItem("userRole");
    if (token) {
        if (role === "ADMIN" || role === "MANAGER") navigate("/admin/dashboard", { replace: true });
        else if (role === "SALES") navigate("/sales/dashboard", { replace: true });
        else navigate("/", { replace: true });
    }
}, [navigate]);

    const [formData, setFormData] = useState({ email: "", password: "" });
    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [apiError, setApiError] = useState("");

    const validate = () => {
        const newErrors = {};
        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = "Enter a valid email address";
        }
        if (!formData.password) {
            newErrors.password = "Password is required";
        } else if (formData.password.length < 4) {
            newErrors.password = "Password must be at least 4 characters";
        }
        return newErrors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
        if (apiError) setApiError("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setLoading(true);
        setApiError("");

        try {
            const response = await axiosInstance.post("/api/auth/login", {
                email: formData.email,
                password: formData.password,
            });

            const { token, userId, name, email, role } = response.data.data;

            localStorage.setItem("token", token);
            localStorage.setItem("userId", userId);
            localStorage.setItem("userName", name);
            localStorage.setItem("userEmail", email);
            localStorage.setItem("userRole", role);

            // Role-based redirect — adjust routes to match your app
            // if (role === "ADMIN" || role === "MANAGER") {
            //     navigate("/admin/dashboard");
            // } else if (role === "SALES") {
            //     navigate("/sales/dashboard");
            // } else {
            //     navigate("/");
            // }
            // Change all 3 navigate calls in handleSubmit:
            if (role === "ADMIN" || role === "MANAGER") {
                navigate("/admin/dashboard", { replace: true }); 
            } else if (role === "SALES") {
                navigate("/sales/dashboard", { replace: true });  
            } else {
                navigate("/", { replace: true });                 
            }
        } catch (err) {
            const message =
                err.response?.data?.message ||
                err.response?.data?.error ||
                "Invalid email or password. Please try again.";
            setApiError(message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "linear-gradient(135deg, #f0f4ff 0%, #e8f5e9 100%)",
                px: 2,
            }}
        >
            <Paper
                elevation={0}
                sx={{
                    width: "100%",
                    maxWidth: 460,
                    borderRadius: 4,
                    border: "1px solid rgba(0,0,0,0.08)",
                    overflow: "hidden",
                    boxShadow: "0 8px 40px rgba(0,0,0,0.08)",
                }}
            >
                {/* Header stripe */}
                <Box
                    sx={{
                        background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
                        px: 4,
                        py: 4,
                        textAlign: "center",
                    }}
                >
                    <Box
                        component="img"
                        src="/images/lider_new2.png"
                        alt="Lider Logo"
                        sx={{
                            height: 48,
                            mb: 2,
                            filter: "brightness(0) invert(1)",
                            objectFit: "contain",
                        }}
                        onError={(e) => {
                            e.target.style.display = "none";
                        }}
                    />
                    <Typography
                        variant="h5"
                        sx={{ color: "#fff", fontWeight: 700, letterSpacing: 0.5 }}
                    >
                        Welcome Back
                    </Typography>
                    <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.75)", mt: 0.5 }}>
                        Sign in to your Lider Technologies account
                    </Typography>
                </Box>

                {/* Form area */}
                <Box
                    component="form"
                    onSubmit={handleSubmit}
                    noValidate
                    sx={{ px: 4, py: 4, background: "#fff" }}
                >
                    {apiError && (
                        <Alert
                            severity="error"
                            sx={{ mb: 3, borderRadius: 2, fontSize: "0.875rem" }}
                            onClose={() => setApiError("")}
                        >
                            {apiError}
                        </Alert>
                    )}

                    {/* Email */}
                    <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75, color: "text.primary" }}>
                        Email Address
                    </Typography>
                    <TextField
                        fullWidth
                        name="email"
                        type="email"
                        placeholder="you@example.com"
                        value={formData.email}
                        onChange={handleChange}
                        error={Boolean(errors.email)}
                        helperText={errors.email}
                        autoComplete="email"
                        disabled={loading}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <EmailOutlinedIcon
                                        sx={{
                                            fontSize: 20,
                                            color: errors.email ? "error.main" : "text.secondary",
                                        }}
                                    />
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            mb: 3,
                            "& .MuiOutlinedInput-root": {
                                borderRadius: 2,
                                backgroundColor: "rgba(0,0,0,0.02)",
                            },
                        }}
                    />

                    {/* Password */}
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 0.75 }}>
                        <Typography variant="body2" fontWeight={600} sx={{ color: "text.primary" }}>
                            Password
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                color: "primary.main",
                                cursor: "pointer",
                                fontWeight: 500,
                                fontSize: "0.8rem",
                                "&:hover": { textDecoration: "underline" },
                            }}
onClick={() => navigate("/forgot-password")}
                        >
                            Forgot password?
                        </Typography>
                    </Box>
                    <TextField
                        fullWidth
                        name="password"
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter your password"
                        value={formData.password}
                        onChange={handleChange}
                        error={Boolean(errors.password)}
                        helperText={errors.password}
                        autoComplete="current-password"
                        disabled={loading}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <LockOutlinedIcon
                                        sx={{
                                            fontSize: 20,
                                            color: errors.password ? "error.main" : "text.secondary",
                                        }}
                                    />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={() => setShowPassword(!showPassword)}
                                        edge="end"
                                        size="small"
                                        tabIndex={-1}
                                    >
                                        {showPassword ? (
                                            <VisibilityOff sx={{ fontSize: 20 }} />
                                        ) : (
                                            <Visibility sx={{ fontSize: 20 }} />
                                        )}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            mb: 3.5,
                            "& .MuiOutlinedInput-root": {
                                borderRadius: 2,
                                backgroundColor: "rgba(0,0,0,0.02)",
                            },
                        }}
                    />

                    {/* Submit */}
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        disabled={loading}
                        sx={{
                            py: 1.5,
                            borderRadius: 2,
                            fontSize: "1rem",
                            fontWeight: 600,
                            textTransform: "none",
                            background: "linear-gradient(135deg, #1976d2, #1565c0)",
                            boxShadow: "0 4px 15px rgba(25, 118, 210, 0.3)",
                            "&:hover": {
                                background: "linear-gradient(135deg, #1565c0, #0d47a1)",
                                boxShadow: "0 6px 20px rgba(25, 118, 210, 0.4)",
                            },
                            "&:disabled": { opacity: 0.7 },
                        }}
                    >
                        {loading ? (
                            <CircularProgress size={22} sx={{ color: "#fff" }} />
                        ) : (
                            "Sign In"
                        )}
                    </Button>
{/* 
                    <Divider sx={{ my: 3, fontSize: "0.8rem", color: "text.disabled" }}>
                        Lider Technologies
                    </Divider>

                    <Typography
                        variant="caption"
                        sx={{
                            display: "block",
                            textAlign: "center",
                            color: "text.secondary",
                            lineHeight: 1.6,
                        }}
                    >
                        By signing in, you agree to our{" "}
                        <Typography
                            component="span"
                            variant="caption"
                            sx={{ color: "primary.main", cursor: "pointer" }}
                        >
                            Terms of Service
                        </Typography>{" "}
                        and{" "}
                        <Typography
                            component="span"
                            variant="caption"
                            sx={{ color: "primary.main", cursor: "pointer" }}
                        >
                            Privacy Policy
                        </Typography>
                        .
                    </Typography> */}
                </Box>
            </Paper>
        </Box>
    );
};

export default Login;
